import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import { Drawer } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import WorkIcon from "@mui/icons-material/Work";

export default function Sidebar({
  isDrawer,
  handleClose,
  homeRef,
  aboutRef,
  skillRef,
  projectRef,
  contactRef,
}) {
 
  const sideBarData = [
    { name: "Home", icon: <HomeIcon />, ref: homeRef },
    { name: "About", icon: <AssignmentIndIcon />, ref: aboutRef },
    { name: "Skill", icon: <MenuBookIcon />, ref: skillRef },
    { name: "Projects", icon: <WorkIcon />, ref: projectRef },
    { name: "Contact", icon: <MailIcon />, ref: contactRef },
  ];
  return (
    <div>
      <Drawer
        anchor="left"
        open={isDrawer}
        onClose={handleClose}
        PaperProps={{
          style: {
            border: "none",
            backgroundColor: "rgba(0, 0, 0, 0.576)",
          },
        }}
      >
        <Box
          sx={{
            width: "auto",
            height: "100vh",
          }}
          role="presentation"
        >
          <List>
            {sideBarData.map((item, index) => (
              <ListItem
                sx={{ color: "white" }}
                key={item.name}
                disablePadding
                onClick={() => {
                  item.ref.current.scrollIntoView();
                  console.log(item.name);
                  setTimeout(() => {
                    handleClose();
                  }, 1000);
                }}
              >
                <ListItemButton>
                  <ListItemIcon sx={{ color: "white" }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </div>
  );
}
